const STEP = {
  LENGTH:      1,
  QUANTITY:    2,
  ACCESSORIES: 3,
  REVIEW:      4,
};

const VALID_STEPS = [STEP.LENGTH, STEP.QUANTITY, STEP.ACCESSORIES, STEP.REVIEW];

const initRadioHireController = () => {
  if (!document.querySelector('.rh-step')) return;

  function getCurrentStep() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') === 'true') return STEP.REVIEW;
    const raw = parseInt(params.get('step') || '1');
    return VALID_STEPS.indexOf(raw) !== -1 ? raw : STEP.LENGTH;
  }

  function showStep(step) {
    document.querySelectorAll('.rh-step').forEach(function (el) {
      const elStep = parseInt(el.dataset.step);
      el.classList.toggle('is-active', elStep === step);
    });
  }

  function guardStep(step) {
    const hire = JSON.parse(sessionStorage.getItem('rhHire') || '{}');
    if (step >= STEP.QUANTITY    && !hire.startDate)   return STEP.LENGTH;
    if (step >= STEP.ACCESSORIES && !hire.quantity)    return STEP.QUANTITY;
    if (step >= STEP.REVIEW      && !hire.accessories) return STEP.ACCESSORIES;
    return step;
  }

  const step    = getCurrentStep();
  const guarded = guardStep(step);

  if (guarded !== step) {
    const url = new URL(window.location.href);
    url.searchParams.set('step', guarded);
    window.location.replace(url.toString());
    return;
  }

  showStep(step);

  window.updateProgress = function (s) {
    const items = document.querySelectorAll('.rh-progress__item');
    items.forEach(function (item) {
      const idx = parseInt(item.dataset.stepIndex);
      item.classList.remove('is-active', 'is-complete');
      if (idx < s)   item.classList.add('is-complete');
      if (idx === s) item.classList.add('is-active');
    });
  };
};

export default initRadioHireController;
